// extracted by mini-css-extract-plugin
export var trigger = "CombosInfo-module--trigger--1dee4";